import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js'
import { gsap } from "gsap";
import { ScrollTrigger, MatchMedia, ScrollSmoother } from "gsap/all";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

/* ------------- VARIABLES ------------- */
let camera, scene, lightGroup, model, renderer, currentSection, smoother,
    sectionOffsets = [], // for spacing
    mouse = { x: 0, y: 0 }, // for mousetilt function
    mm = gsap.matchMedia(),
    sections = document.querySelectorAll('#homepage-slider > section[data-slide-index]'), // content sections above
    sectionIndicators = document.querySelectorAll('.indicators > span'), // left side circles
    lipidPositions = [
        { x: -0.25, y: 0.2, z: 0.4, rotateX: 0.2, rotateY: 1, rotateZ: .9 },// 0 Hero
        { x: -1, y: 0, z: -1, rotateX: 0.3, rotateY: 2, rotateZ: .9 },// 1 Banner Text with button
        { x: -.6, y: 0, z: 0, rotateX: 0, rotateY: 2, rotateZ: 2 },// 2 News and Events Cards
        { x: -0.6, y: 0, z: 0, rotateX: 0.2, rotateY: 2.2, rotateZ: 0.9 },// 3 Systems gallery slider 
        { x: 0.6, y: 0, z: -0.3, rotateX: 0.3, rotateY: 2, rotateZ: 2.0 },// 4 Blank section to rotate lipid
        { x: 0.4, y: 0, z: 0, rotateX: -2, rotateY: 1, rotateZ: 0.2 },// 5 Our Services CTA
        { x: 1.2, y: 0, z: 0, rotateX: 0.0, rotateY: 0.7, rotateZ: 2.4 },// 6 Our Nanoparticle Technology CTA
        { x: -0.8, y: 0, z: 0, rotateX: 0.3, rotateY: 2, rotateZ: 1.9 },// 7 Nanoparticle Drug Delivery CTA
        { x: 1.2, y: 0, z: 0, rotateX: 0.2, rotateY: 1, rotateZ: 1.9 },// 8 Industrial Applications CTA 
        { x: -0.8, y: 0, z: 0, rotateX: 0.2, rotateY: 1, rotateZ: .9 },// 9 Nanoparticle Drug Delivery CTA
    ];

/* ------------- GSAP takes over scrolling ------------- */
smoother = ScrollSmoother.create({
    content: '#homepage-slider',
    smooth: 1.1,               // how long (in seconds) it takes to "catch up" to the native scroll position
    effects: false,           // looks for data-speed and data-lag attributes on elements
    smoothTouch: false,        // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
    // normalizeScroll: true //  for mobile
});

/* ------------- DOC READY ------------- */
document.addEventListener("DOMContentLoaded", function () {

    heroText(); // move hero text
    populateSectionOffsets() // get pageYOffset of sections on homepage tops
    getIndexOfSectionCurrentlyInViewport() // find where we are on the page
    showCurrentIndicator(getIndexOfSectionCurrentlyInViewport())// left side indicators

    cvs(); // our main canvas animation

    mm.add("(min-width: 1024px)", () => {

        // homepage systems
        gsap.to('#systems-section', {
            xPercent: -50,
            duration: 5,
            scrollTrigger: {
                trigger: "#systems-section",
                start: "top top",
                pin: true,
                pinSpacing: true,
                scrub: true,
                invalidateOnRefresh: true,
                anticipatePin: 0,
                end: "+=" + (window.innerHeight * 1.5),
                onEnter: populateSectionOffsets,
                onLeave: populateSectionOffsets,
            }
        });

        // homepage news cards
        gsap.to('#news-section', {
            xPercent: -50,
            duration: 5,
            scrollTrigger: {
                trigger: "#news-section",
                start: "top top",
                pin: true,
                pinSpacing: true,
                scrub: true,
                invalidateOnRefresh: true,
                anticipatePin: 1,
                end: "+=" + (window.innerHeight * 1.5),
                onEnter: populateSectionOffsets,
                onLeave: populateSectionOffsets,
            }
        });

    });

    // scroll the lipid out of view on mobile
    mm.add("(max-width: 1023px)", () => {
        gsap.to("#lipidMount", {
            yPercent: -100,
            duration: 10,
            scrollTrigger: {
                trigger: "body.home #homepage-slider section[data-slide-index='1']",
                start: 25,
                scrub: true,
            }
        })
    });

    /* ------------- EVENT: RESIZE ------------- */
    window.addEventListener('resize', function () {
        heroText(); // move h1s in hero
        populateSectionOffsets() // get pageYOffset of sections on homepage tops
        getIndexOfSectionCurrentlyInViewport() // find where we are on the page
        showCurrentIndicator(getIndexOfSectionCurrentlyInViewport())// left side indicators
    })

    /* -------------  EVENT: SCROLL ------------- */
    window.addEventListener('scroll', function () {
        // side effects
        showCurrentIndicator(currentSection) //left side indicators

        getIndexOfSectionCurrentlyInViewport() // update the state of our variable that tracks our viewport
        // console.log(`currentSection is`,currentSection);
        // console.log(`smoother offset is`,smoother.scrollTop());

    })

});


/* ------------- FUNCTIONS ------------- */

// hero text animation
function heroText() {

    let heroTextContainer = document.querySelector('.hero-text'),
        left = heroTextContainer.querySelector('.left'),
        right = heroTextContainer.querySelector('.right');

    if (window.innerWidth < 1024) {
        left.style.transform = 'translateY(0px) '
        right.style.transform = 'translateY(0px) '
    } else {
        setTimeout(() => {
            left.style.transform = 'translateY(-210px) '
            right.style.transform = 'translateY(200px) '
        }, 400);
    }
}

// change background color of dots
function showCurrentIndicator(index) {

    for (let i = 0; i < sectionIndicators.length; i++) {
        if (i == currentSection) {
            //sectionIndicators[index].style.backgroundColor = 'rgba(255,255,255,1)';
            sectionIndicators[i].classList.remove('bg-transparent')
            sectionIndicators[i].classList.add('bg-white')

        } else {
            // sectionIndicators[index].style.backgroundColor = 'rgba(255,255,255,0)';
            sectionIndicators[i].classList.remove('bg-white')
            sectionIndicators[i].classList.add('bg-transparent')
        }
    }
}

// get offset tops of all sections
function populateSectionOffsets() {
    sectionOffsets = []
    if (window.innerWidth > 1023 && smoother) {
        for (let i = 0; i < sections.length; i++) {
            let offset = smoother.offset(sections[i], "top top");
            sectionOffsets.push(offset)
        }
    }
    console.log('sectionOffsets are', sectionOffsets)
}

// utility to find current section
function getIndexOfSectionCurrentlyInViewport() {
    let curScroll = window.pageYOffset;
    const closestOffsetToCurscroll = sectionOffsets.reduce((a, b) => {
        return Math.abs(b - curScroll) < Math.abs(a - curScroll) ? b : a
    }, 0);
    currentSection = sectionOffsets.indexOf(closestOffsetToCurscroll);
}

// canvas
function cvs() {

    const moveSpotLights = () => {
        lightGroup.position.x = model.position.x
        lightGroup.position.y = model.position.y
        lightGroup.position.z = model.position.z
        return null
    }

    init()

    function init() {

        // camera
        camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.25, 2000000);
        camera.position.set(0, 0, 3); // x, y, z

        // scene
        scene = new THREE.Scene();

        // LOAD OUR TEXTURES
        const loader = new GLTFLoader().setPath('/wp-content/themes/diant/public/images/');

        // dracoloader
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
        loader.setDRACOLoader(dracoLoader);

        loader.load('lipid.glb', function (gltf) {

            gltf.scene.traverse(function (child) {
                if (child.isMesh) {
                    child.castShadow = true;
                    child.receiveShadow = true;
                }
            });

            model = gltf.scene

            // scale
            model.scale.set(0.33, 0.33, 0.33);

            // position
            model.position.setX(0);
            model.position.setY(0);
            model.position.setZ(0);

            // initial rotation
            model.rotation.x = Math.PI / 5
            model.rotation.y = Math.PI / 2

            /////////////////////////// LIGHTS CREATION ///////////////////////////////////
            const ambientLight = new THREE.AmbientLight(0xFFFFFF, 0.5);
            scene.add(ambientLight);

            const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
            directionalLight.castShadow = true;
            directionalLight.position.z = 0.5
            directionalLight.position.x = 0.5
            const dirTarget = new THREE.Object3D();
            dirTarget.position.set(0, 0, 0);
            directionalLight.target = dirTarget;
            scene.add(directionalLight);

            const rectLight1 = new THREE.RectAreaLight(0x2DAFFF, 0.2, 2, 2)
            rectLight1.position.y = model.position.y - 1
            rectLight1.position.z = model.position.z + 1
            rectLight1.rotation.x = Math.PI / 2
            rectLight1.rotation.y = 0.6
            rectLight1.rotation.z = .5

            rectLight1.target = model.children[0];

            const rectLight2 = new THREE.RectAreaLight(0xADD8E6, 0.2, 2, 2)
            rectLight2.position.y = model.position.y - 1
            rectLight2.position.z = model.position.z + 1
            rectLight2.rotation.x = Math.PI / 2
            rectLight2.rotation.y = -0.60
            rectLight2.rotation.z = 0.5

            rectLight2.target = model.children[0];

            const spotLight1 = new THREE.SpotLight(0xFFFFFF, 8, 1.6, 1, 1, 2);
            spotLight1.position.y = model.position.y + 1
            spotLight1.position.z = model.position.z + 0.8
            spotLight1.position.x = model.position.x - 0.4
            spotLight1.castShadow = true;
            spotLight1.shadow.radius = 32;
            spotLight1.target = model.children[0];

            const spotLight2 = new THREE.SpotLight(0xFFF3B4, 10, 1.6, 1, 1, 2);
            spotLight2.position.y = model.position.y + 1
            spotLight2.position.z = model.position.z + 0.8
            spotLight2.position.x = model.position.x + 0.4
            spotLight2.castShadow = true;
            spotLight2.shadow.radius = 8;
            spotLight2.target = model.children[0];


            lightGroup = new THREE.Group()
            lightGroup.add(rectLight1);
            lightGroup.add(rectLight2);
            lightGroup.add(spotLight1);
            lightGroup.add(spotLight2);
            scene.add(lightGroup);

            /////////////////////////// LIGHTS CREATION ENDS ////////////////////////////////

            scene.add(model);
            scaleModel()
            render();
            animate();

        });


        renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.physicallyCorrectLights = true;

        renderer.gammaFactor = 1;
        renderer.outputEncoding = THREE.sRGBEncoding;
        renderer.shadowMap.enabled = true;
        renderer.shadowMapSoft = true;
        renderer.shadowMapType = THREE.PCFSoftShadowMap;

        renderer.gammaOutput = true;
        renderer.toneMapping = THREE.ACESFilmicToneMapping;
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(window.innerWidth, window.innerHeight);

        renderer.toneMappingExposure = 1;

        let mount = document.querySelector('#lipidMount');
        mount.appendChild(renderer.domElement)

    }


    // renders our scene and is updated by animate
    function render() {
        renderer.render(scene, camera);
    }

    // resizes our model - added to resize event listener
    function scaleModel() {
        console.log('scaling model to size')
        if (window.innerWidth < 1024) {

            if (window.innerWidth < 768) {
                // mobile
                model.scale.set(0.3, 0.3, 0.3);
            } else {
                // tablet
                model.scale.set(0.4, 0.4, 0.4);
            }
        } else {
            // desktop
            model.scale.set(0.33, 0.33, 0.33);
        }
    }

    // our animation loop
    function animate() {
        model.children[0].rotation.y += 0.006 // rotate on face 

        if (window.innerWidth < 1024) {

            if (window.innerWidth < 768) {
                //console.log('mobile')
                // model.scale.set(0.3, 0.3, 0.3);
                gsap.to(model.position, {
                    duration: 2,
                    x: -0.06125,
                    y: 0.25,
                    z: 0.5
                })
                //rotateX: 0.2, rotateY: 1, rotateZ: .9
                gsap.to(model.rotation, {
                    duration: 2,
                    x: 0.2,
                    y: 1,
                    z: .9
                })
            } else {
                //console.log('tablet')
                // model.scale.set(0.4,0.4,0.4);
                gsap.to(model.position, {
                    duration: 2,
                    x: -0.06125,
                    y: 0.25,
                    z: 0.5
                })
                //rotateX: 0.2, rotateY: 1, rotateZ: .9
                gsap.to(model.rotation, {
                    duration: 2,
                    x: 0.2,
                    y: 1,
                    z: .9
                })
            }

        } else {

            //console.log('desktop')
            // model.scale.set(0.33, 0.33, 0.33);
            if (lipidPositions.length - 1 >= currentSection) {
                let coordinates = lipidPositions[currentSection],
                    pos = new THREE.Vector3(coordinates.x, coordinates.y, coordinates.z);
                const rotateX = coordinates.rotateX
                const rotateY = coordinates.rotateY
                const rotateZ = coordinates.rotateZ
                gsap.to(model.position, {
                    duration: 2,
                    x: pos.x,
                    y: pos.y,
                    z: pos.z
                })
                gsap.to(model.rotation, {
                    duration: 2,
                    x: rotateX,
                    y: rotateY,
                    z: rotateZ
                })
            }

        }
        if (window.innerWidth >= 1024) {
            moveSpotLights();
        }
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.render(scene, camera);
        requestAnimationFrame(animate);
    }



    // resizes our scene - added to window
    function resize() {
        camera.aspect = window.innerWidth / window.innerHeight
        camera.updateProjectionMatrix()
        renderer.setSize(window.innerWidth, window.innerHeight)
        render()
    }

    // mouse tilt with camera
    function mouseTilt(e) {
        mouse.xFromCenter = (e.clientX / window.innerWidth) * 2 - 1;
        mouse.yFromCenter = - (e.clientY / window.innerHeight) * 2 + 1;

        let cameraPosition = new THREE.Vector3(mouse.xFromCenter / 25, mouse.yFromCenter / 25, 3)

        //lerp args are positon and speed
        camera.position.lerp(cameraPosition, 0.33)

    }

    // event listeners
    if (window.innerWidth >= 1024) {
        window.addEventListener('mousemove', mouseTilt)
    }

    window.addEventListener('resize', function () {
        resize() // resize our canvas
        scaleModel() // scale our model
        if (window.innerWidth >= 1024) {
            window.addEventListener('mousemove', mouseTilt)
        } else {
            window.removeEventListener('mousemove', mouseTilt)
        }
    })

}




// let mvmt = {
//     '1a': { x: -0.25, y: 0.2, z: 0.4, rotateX: 0.2, rotateY: 1, rotateZ: .9 },// 1 Hero
//     '2a': { x: -1, y: 0, z: -1, rotateX: 0.3, rotateY: 2, rotateZ: .9 },// 2 Banner Text with button
//     '3a': { x: -.6, y: 0, z: 0, rotateX: 0, rotateY: 2, rotateZ: 2 },// 3 News and Events Cards
//     '4a': { x: -.6, y: 0, z: 0, rotateX: 0, rotateY: 2, rotateZ: 2 }, // 4 diant offers... paragraph
//     '5a': { x: -0.6, y: 0, z: 0, rotateX: 0.2, rotateY: 2.2, rotateZ: 0.9 },// 5 Systems gallery slider
//     '5b': { x: -0.6, y: 0, z: 0, rotateX: 0.2, rotateY: 2.2, rotateZ: 0.9 },// 5 Systems gallery slider  2
//     '6a': { x: 0.6, y: 0, z: -0.3, rotateX: 0.3, rotateY: 2, rotateZ: 2.0 },// 6 Blank section to rotate lipid
//     '7a': { x: 0.4, y: 0, z: 0, rotateX: -2, rotateY: 1, rotateZ: 0.2 },// 7 Our Services CTA
//     '8a': { x: 1.2, y: 0, z: 0, rotateX: 0.0, rotateY: 0.7, rotateZ: 2.4 },// 8 Our Nanoparticle Technology CTA
//     '9a': { x: -0.8, y: 0, z: 0, rotateX: 0.3, rotateY: 2, rotateZ: 1.9 },// 9 Nanoparticle Drug Delivery CTA
//     '10a': { x: 1.2, y: 0, z: 0, rotateX: 0.2, rotateY: 1, rotateZ: 1.9 },// 10 Industrial Applications CTA
// }

// function getCurrentViewportsKey() {
//     let x = ''
//     return x;
// }


